import { useParams } from "react-router-dom";
import { type User } from "../api/client";
import { DailyMealLogsPage } from "./DailyMealLogsPage";

export function HistoryDayPage({ user }: { user: User }) {
  const { date } = useParams();

  if (!date) return null;

  return <DailyMealLogsPage user={user} date={date} mode="history" />;
}
